<template>
  <div class="main-mobile-footer" :class="footerClasses">
    <template v-if="!isEmptyApp">
      <slot />
    </template>
    <MainMobileFooterNeedHelp class="main-mobile-footer__item" />
    <slot name="after" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useHubspot } from '@/plugins/hubspot'

import MainMobileFooterNeedHelp from './FooterNeedHelp.vue'

type Props = {
  isEmptyApp?: boolean
}

const props = defineProps<Props>()

const hubspot = useHubspot()

const footerClasses = computed(() => ({
  'main-mobile-footer--empty': props.isEmptyApp,
  'main-mobile-footer--shrink': !hubspot,
}))
</script>

<style>
.main-mobile-footer {
  @apply shrink-0;
  @apply absolute bottom-0 inset-x-0;
  @apply grid grid-cols-5;
  @apply pb-safe;
  @apply bg-gray-200 dark:bg-gray-900;
  @apply z-40;

  &--shrink {
    @apply grid-cols-4;
  }

  &--empty {
    @apply grid-cols-2;
  }

  &--shrink:is(&--empty) {
    @apply grid-cols-1;
  }

  &__item {
    @apply relative;
    @apply flex flex-col items-center justify-center;
    @apply py-3;
    @apply text-center;
    @apply text-gray-400 hover:text-primary hover:dark:text-indigo-300;
    @apply cursor-pointer;

    &:first-child:last-child {
      @apply col-start-4;
    }
  }

  &__status-icon {
    @apply !size-3;
    @apply absolute;
    @apply top-1.5 left-1/2;
    @apply text-indigo-400;
    @apply translate-x-2;
  }
}

.main-mobile-footer-icon {
  @apply size-7;
}

.main-mobile-footer-caption {
  @apply max-w-[90%];
  @apply text-sm sm:text-xs;
  @apply truncate;
}
</style>
